var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[(_vm.selectedHome === 'background')?_c('HomeBackground'):_c('HomeFunctions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }